export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "SP基础知识",
    slug: "sp-basics",
    description: "了解打屁股SP的定义、起源、文化背景与基本概念，建立正确的认知框架。",
    icon: "ri-book-open-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20library%20setting%20with%20soft%20amber%20lighting%2C%20open%20book%20on%20wooden%20desk%2C%20cozy%20reading%20atmosphere%2C%20cream%20walls%2C%20elegant%20composition%2C%20editorial%20photography%20style%20with%20warm%20tones%20and%20gentle%20shadows&width=800&height=450&seq=cat-basics-01&orientation=landscape"
  },
  {
    id: "cat-2",
    name: "SP安全须知",
    slug: "sp-safety",
    description: "掌握SP活动中的安全原则、安全词机制、身体保护要点与风险防范知识。",
    icon: "ri-shield-check-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20safety%20concept%20photography%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20elegant%20composition%20with%20protective%20elements%2C%20gentle%20amber%20and%20beige%20tones%2C%20editorial%20style%20with%20sophisticated%20atmosphere&width=800&height=450&seq=cat-safety-02&orientation=landscape"
  },
  {
    id: "cat-3",
    name: "SP工具选择",
    slug: "sp-tools",
    description: "了解各类SP工具的材质、特点、使用场景与选购建议，找到最适合的工具。",
    icon: "ri-tools-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20various%20elegant%20objects%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20warm%20beige%20and%20taupe%20tones%2C%20editorial%20catalog%20style%20with%20gentle%20shadows&width=800&height=450&seq=cat-tools-03&orientation=landscape"
  },
  {
    id: "cat-4",
    name: "SP技巧方法",
    slug: "sp-techniques",
    description: "学习SP的基础与进阶技巧、手法教学、力度控制与节奏把握方法。",
    icon: "ri-lightbulb-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20studio%20scene%20with%20soft%20amber%20lighting%2C%20elegant%20hands%20gesture%20in%20soft%20focus%2C%20cream%20background%2C%20sophisticated%20composition%2C%20editorial%20photography%20with%20gentle%20warm%20tones%20and%20refined%20atmosphere&width=800&height=450&seq=cat-tech-04&orientation=landscape"
  },
  {
    id: "cat-5",
    name: "SP注意事项",
    slug: "sp-precautions",
    description: "了解SP前后的准备工作、身体护理、心理调适与沟通边界等重要事项。",
    icon: "ri-error-warning-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Soft%20minimalist%20wellness%20scene%20with%20warm%20cream%20background%2C%20gentle%20natural%20light%2C%20elegant%20composition%20of%20self-care%20elements%2C%20calm%20and%20soothing%20atmosphere%2C%20editorial%20style%20with%20warm%20beige%20and%20soft%20taupe%20tones&width=800&height=450&seq=cat-prec-05&orientation=landscape"
  },
  {
    id: "cat-6",
    name: "SP新手指南",
    slug: "sp-beginner",
    description: "专为SP新手准备的入门指南，从零开始了解SP的方方面面。",
    icon: "ri-compass-3-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20learning%20environment%20with%20soft%20golden%20lighting%2C%20notebook%20and%20pen%20on%20cream%20desk%2C%20cozy%20atmosphere%2C%20elegant%20composition%2C%20editorial%20photography%20with%20warm%20amber%20and%20soft%20beige%20tones&width=800&height=450&seq=cat-begin-06&orientation=landscape"
  }
];